export var ToolEnumType;
(function (ToolEnumType) {
    ToolEnumType["SortDirection"] = "SortDirection";
    ToolEnumType["AggregateColumnOperation"] = "AggregateColumnOperation";
    ToolEnumType["DateFrequency"] = "DateFrequency";
    ToolEnumType["DateAddType"] = "DateAddType";
    ToolEnumType["DateAddUnit"] = "DateAddUnit";
    ToolEnumType["DateUnitType"] = "DateUnitType";
    ToolEnumType["DatePartType"] = "DatePartType";
    ToolEnumType["JoinOperator"] = "JoinOperator";
    ToolEnumType["JoinPattern"] = "JoinPattern";
    ToolEnumType["FilterStatementOp"] = "FilterStatementOp";
    ToolEnumType["ColumnType"] = "ColumnType";
    ToolEnumType["PeriodAddType"] = "PeriodAddType";
})(ToolEnumType || (ToolEnumType = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["ASCENDING"] = "ascending";
    SortDirection["DESCENDING"] = "descending";
})(SortDirection || (SortDirection = {}));
export var DateAddUnit;
(function (DateAddUnit) {
    DateAddUnit["Years"] = "Years";
    DateAddUnit["Months"] = "Months";
    DateAddUnit["Days"] = "Days";
    DateAddUnit["Hours"] = "Hours";
    DateAddUnit["Minutes"] = "Minutes";
    DateAddUnit["Seconds"] = "Seconds";
    DateAddUnit["Milliseconds"] = "Milliseconds";
})(DateAddUnit || (DateAddUnit = {}));
export var DateAddType;
(function (DateAddType) {
    DateAddType["Number"] = "number";
    DateAddType["Column"] = "column";
    DateAddType["None"] = "none";
})(DateAddType || (DateAddType = {}));
export var DatePartType;
(function (DatePartType) {
    DatePartType["YEAR"] = "year";
    DatePartType["MONTH"] = "month";
    DatePartType["QUARTER"] = "quarter";
    DatePartType["WEEK"] = "week";
    DatePartType["DAY"] = "day";
    DatePartType["WEEKDAY"] = "weekday";
    DatePartType["HOUR"] = "hour";
    DatePartType["MINUTE"] = "minute";
    DatePartType["SECOND"] = "second";
})(DatePartType || (DatePartType = {}));
// this is for dateDiff
export var DateUnitType;
(function (DateUnitType) {
    DateUnitType["Year"] = "year";
    DateUnitType["Month"] = "month";
    DateUnitType["Day"] = "day";
    DateUnitType["Hour"] = "hour";
    DateUnitType["Minute"] = "minute";
    DateUnitType["Second"] = "second";
})(DateUnitType || (DateUnitType = {}));
// join enums
export var JoinOperator;
(function (JoinOperator) {
    JoinOperator["EQUAL"] = "equal";
    JoinOperator["LESS_THAN"] = "less_than";
    JoinOperator["LESS_THAN_OR_EQUAL"] = "less_than_or_equal";
    JoinOperator["GREATER_THAN"] = "greater_than";
    JoinOperator["GREATER_THAN_OR_EQUAL"] = "greater_than_or_equal";
    JoinOperator["LIKE"] = "like";
})(JoinOperator || (JoinOperator = {}));
export var JoinPattern;
(function (JoinPattern) {
    JoinPattern["STARTS_WITH"] = "starts_with";
    JoinPattern["ENDS_WITH"] = "ends_with";
    JoinPattern["CONTAINS"] = "contains";
})(JoinPattern || (JoinPattern = {}));
export var FilterStatementOp;
(function (FilterStatementOp) {
    FilterStatementOp["LESS_THAN"] = "less_than";
    FilterStatementOp["LESS_THAN_EQUALS"] = "less_than_equals";
    FilterStatementOp["EQUALS"] = "equals";
    FilterStatementOp["NOT_EQUALS"] = "not_equals";
    FilterStatementOp["GREATER_THAN_EQUALS"] = "greater_than_equals";
    FilterStatementOp["GREATER_THAN"] = "greater_than";
    FilterStatementOp["IS_NULL"] = "is_null";
    FilterStatementOp["IS_NOT_NULL"] = "is_not_null";
    FilterStatementOp["STARTS_WITH"] = "starts_with";
    FilterStatementOp["ENDS_WITH"] = "ends_with";
    FilterStatementOp["CONTAINS"] = "contains";
    FilterStatementOp["NOT_CONTAINS"] = "not_contains";
})(FilterStatementOp || (FilterStatementOp = {}));
export var PeriodAddType;
(function (PeriodAddType) {
    PeriodAddType["Number"] = "number";
    PeriodAddType["Column"] = "column";
})(PeriodAddType || (PeriodAddType = {}));
//# sourceMappingURL=toolEnumTypes.js.map